import { Capacitor } from "@capacitor/core";

export enum Platform {
  Android = "android",
  iOS = "ios",
  Web = "web",
}

export interface DeviceInfo {
  platform: Platform;
  isNativeApp: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isWeb: boolean;
}

export const getDeviceInfo = (): DeviceInfo => {
  const platform = Capacitor.getPlatform() as Platform;
  const isNativeApp = Capacitor.isNativePlatform();

  return {
    platform,
    isNativeApp: isNativeApp,
    isAndroid: platform === Platform.Android,
    isIOS: platform === Platform.iOS,
    isWeb: platform === Platform.Web,
  };
};
